import { connect } from 'react-redux';

import { getFormValues, reset } from 'redux-form';

import AddDeliveryComponent from '../CallCenter/AddDeliveryComponent';

import { createDelivery } from './actions';

import { formatDeliverySelect } from '../Forms/utils';
import { validateDeliveryCreation } from './utils';

import { deliveryFormName as form } from './constants';

const validate = (values) => validateDeliveryCreation(values);

const mapStateToProps = (state, ownProps) => {
  const formValues = getFormValues(form)(state);
  const deliveryTypeOptions = formatDeliverySelect(ownProps?.deliveryTypes);
  const initialValues = {
    type: deliveryTypeOptions?.[0]?.value,
  };

  return {
    ...ownProps,
    form,
    formValues,
    initialValues,
    deliveryTypeOptions,
    validate,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (data, props) => {
    const {
      isFrontDesk,
      setPackageChanged = () => {},
      onModalClose,
    } = ownProps;

    const buildingId = props.building.id;
    const formattedData = { ...data, building: buildingId };
    const callback = (res) => {
      if (!res) return null;
      if (isFrontDesk) {
        setPackageChanged();
        dispatch(reset(form));
        return null;
      }
      return onModalClose();
    };
    const successMessage = 'Delivery successfully created';
    return createDelivery(dispatch, formattedData, callback, successMessage);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddDeliveryComponent);
